module.exports = __webpack_public_path__ + "img/운디네 (2).403ceecd.png";